/** Anchors for the hub's Browse by area block, shared by the hub, its tabs and the board chips. */
export const BROWSE_BY_AREA_ID = "browse-by-area";

export function browseByAreaPanelId(tabId: string): string {
  return `${BROWSE_BY_AREA_ID}-${tabId}`;
}
